import script from "./LinkHeaderSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkHeaderSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./LinkHeaderSkeleton.vue?vue&type=style&index=0&id=06aec6ca&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06aec6ca"]])

export default __exports__